import { Instance, flow, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { Registration } from './models/Registration';
import { getEnvironment } from './utils';

export const RegistrationStore = types
  .compose(
    getBaseStore<Instance<typeof Registration>, Instance<typeof Registration>>(
      Registration,
      'registrationId',
      'registration',
    ),
    types.model('RegistrationStore', {}),
  )
  .actions((self: any) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const findByUserId = flow(function*(userId: number) {
      const res = yield apiFetcher.get(`registration/` + userId, undefined, true);
      if (res !== undefined) {
        self.datas.put(res);
        return self.datas.get(((res as unknown) as Instance<typeof Registration>).registrationId.toString());
      }
      return undefined;
    });

    return { findByUserId };
  });
